if (!customElements.get('zh-cart-picks')) {
  customElements.define('zh-cart-picks', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const media = this.querySelector('.zh-cart-picks__media');
      const scroller = this.closest('.t4s-drawer__scroll');
      const extras = this.closest('.zh-cart-extras');
      if (!media || !scroller || !extras) return;

      let ticking = false;
      const syncPeek = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          extras.style.marginTop = '0px';
          if (!this.offsetHeight || !scroller.clientHeight) return;
          const peek = media.getBoundingClientRect().top - extras.getBoundingClientRect().top + media.offsetHeight / 2;
          const above = extras.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
          const gap = scroller.clientHeight - peek - above;
          extras.style.marginTop = gap > 1 ? gap.toFixed(1) + 'px' : '0px';
        });
      };

      const productHandle = href => {
        try {
          const path = new URL(href, location.origin).pathname.replace(/\/$/, '');
          const parts = path.split('/products/');
          return parts.length > 1 ? decodeURIComponent(parts.pop()) : '';
        } catch (e) {
          return '';
        }
      };

      const applyCollectionOrder = () => {
        const sortUrl = this.dataset.sortUrl;
        const grid = this.querySelector('.zh-cart-picks__grid');
        if (!sortUrl || !grid) return;
        fetch(sortUrl, { headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : [])
          .then(handles => {
            if (!Array.isArray(handles) || !handles.length) return;
            const cards = new Map();
            [...grid.children].forEach(card => {
              const handle = productHandle(card.getAttribute('href') || '');
              if (handle) cards.set(handle, card);
            });
            handles.forEach(handle => {
              const card = cards.get(handle);
              if (card) grid.appendChild(card);
            });
            syncPeek();
          })
          .catch(() => {});
      };

      syncPeek();
      applyCollectionOrder();
      const drawer = this.closest('#t4s-mini_cart');
      if (drawer) {
        new MutationObserver(syncPeek).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
      }
      if (!window.ResizeObserver) return;
      const observer = new ResizeObserver(syncPeek);
      observer.observe(scroller);
      const items = scroller.querySelector('[data-cart-items]');
      if (items) observer.observe(items);
    }
  });
}
